import BaseLayer from "./BaseLayer";
import {drawRectangle, mapMotorToCanvas} from "../utils/map_utils";

class RescanCheckPoint extends BaseLayer {

    id = this.props.id;
    label = this.props.label;
    defaultVisible = this.props.tileViewerState[this.props.id];

    draw = () => new Promise((resolve, reject) => {
        let {rescanWorkflow, deviceSettings, tileFlag, textColor} = this.props;
        let {y_fields, tile_width, tile_height, uperpixel} = this.props.slide;

        let data = Object.entries(rescanWorkflow).sort()[this.props.checkpoint][1];
        
        for(let i=0; i< data.length; i++) {
            Object.values(data[i]['scanCellMap']).forEach(scanCell => {
                let motorX = scanCell['position']['xPosition'];
                let motorY = scanCell['position']['yPosition'];
                let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                    {device_settings: deviceSettings});
                if (tileFlag['reverseYTileOrder']['flagY'])
                    y = y_fields * (tile_height * uperpixel) - y;
                let xImageCoord = Math.floor(x / (tile_width * uperpixel));
                let yImageCoord = Math.floor(y / (tile_height * uperpixel));
    
                let bounds = [
                    [(xImageCoord + 0.25) * (tile_width * uperpixel), (yImageCoord + 0.25) * (tile_height * uperpixel)],
                    [(xImageCoord + 0.75) * (tile_width * uperpixel), (yImageCoord + 0.25) * (tile_height * uperpixel)],
                    [(xImageCoord + 0.75) * (tile_width * uperpixel), (yImageCoord + 0.75) * (tile_height * uperpixel)],
                    [(xImageCoord + 0.25) * (tile_width * uperpixel), (yImageCoord + 0.75) * (tile_height * uperpixel)],
                    [(xImageCoord + 0.5) * (tile_width * uperpixel), (yImageCoord + 0.5) * (tile_height * uperpixel)]
                ];
                drawRectangle(bounds, this.layer.getSource(), false, 2, this.props.rescanColor);
            });
        }

        resolve();
    })

}

export default RescanCheckPoint;